import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

//axios.defaults.baseURL = 'https://stgtrainew.mbfit.net/api/v1'; // Staging
axios.defaults.baseURL = 'https://trainew.mbfit.net/api/v1'; // Production
const trainingBackendBaseURL = 'https://trainingstg.mbfit.net';

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('api_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle 401 errors
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('api_token');
      router.push({ name: 'LoginForm' });
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = axios;
Vue.prototype.$trainingBackendBaseURL = trainingBackendBaseURL;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
